import React, { Component } from 'react';

class BaseComponent extends Component {
	log = (...params) => {
		if (window.NO_LOGGING !== true) console.log(this.constructor.name, ':', ...params);
	};
}

export default BaseComponent;
